export const decimalRegexValidator = /^\d+(\.\d{1,2})?$/; // allows upto 2 decimal points only
